module.exports = __webpack_public_path__ + "img/trash.dc2412cc.svg";